/**
 * BombIcon — inline SVG bomb icon for multiplayer bomb feature.
 * Monochromatic, inherits color from parent via currentColor.
 */
export default function BombIcon({ size = 14, className = '' }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      <circle cx="11" cy="15" r="8.5" />
      <rect x="9.5" y="5" width="3" height="3" rx="0.5" />
      <path d="M13.5 6 Q16 3, 19 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
    </svg>
  );
}
